<template>
  <div>
    <div class="left-navigation">
      <div id="logo">
        <img src="@/assets/logo1.png" />
        <span>海深标注平台</span>
      </div>
      <div
        class="menu-item"
        v-for="(m, index) of menuList"
        :key="`menu${index}`"
        :class="m.url === $route.path ? 'active' : ''"
      >
        <div v-if="m.url">
          <div class="item-title" @click="to(m.url)">
            <img :src="require(`@/assets/${m.imageName}.png`)" />
            <span>{{ m.name }}</span>
          </div>
        </div>
        <div v-if="m.sub">
          <div class="item-title">
            <img :src="require(`@/assets/${m.imageName}.png`)" />
            <span>{{ m.name }}</span>
          </div>
          <div v-for="(sub, index) of m.sub" :key="`submenu${index}`">
            <div v-if="sub.name === '退出登录'">
              <div class="item-subtitle" @click="logout()">
                <span>{{ sub.name }}</span>
              </div>
            </div>
            <div v-else-if="sub.name === '修改信息'">
              <div class="item-subtitle" @click="userInfoModalVisible = true">
                <span>{{ sub.name }}</span>
              </div>
            </div>
            <div v-else-if="sub.name !== '退出登录'">
              <div class="item-subtitle" @click="to(sub.url)">
                <span>{{ sub.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
        <span>沪ICP备20000777号-1</span>
      </a>
    </div>
    <el-dialog title="修改信息" :visible.sync="userInfoModalVisible" :before-close="closeDialog">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input
            type="text"
            clearable
            placeholder="请输入用户名"
            v-model="form.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            clearable
            placeholder="请输入密码"
            v-model="form.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            clearable
            placeholder="请确认密码"
            v-model="form.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -80px">
          <el-button type="primary" @click="changeUserInfo('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { passwordSalt } from '@/config';
import * as api from '@/api/api.js';
import { router } from '@/main';
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (value.length < 6) {
          callback(new Error('密码长度至少为6'));
        }
        if (value.search(/[0-9]/) < 0) {
          callback(new Error('密码中必须含有数字'));
        }
        if (value.search(/[a-zA-Z]/) < 0) {
          callback(new Error('密码中必须含有大小写字母'));
        }
        if (this.form.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      menuList: {
        admin: [
          { name: '任务管理', url: '/tasklist', imageName: 'tasklist' },
          { name: '申诉列表', url: '/incorrectlist', imageName: 'tasklist' },
          { name: '标注文档', url: '/annodoc', imageName: 'doc' },
          { name: '测试题集', url: '/examlist', imageName: 'exam' },
          { name: '用户列表', url: '/users', imageName: 'userlist' },
          { name: '标注统计', url: '/salary', imageName: 'statistics' },
          { name: '定向搜索', url: '/search', imageName: 'search' },
          { name: '题目图片', url: '/examimage', imageName: 'pic' },
          { name: '模型审核', url: '/model/audit/list', imageName: 'audit' },
          // { name: '标注统计', url: '/stat', imageName: 'statistics' },
          {
            name: '个人中心',
            sub: [
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        customer: [
          { name: '我的任务', url: '/tasklist', imageName: 'tasklist' },
          {
            name: '个人中心',
            sub: [
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        approver: [
          { name: '我的任务', url: '/tasklist', imageName: 'tasklist' },
          { name: '错误列表', url: '/incorrectlist', imageName: 'tasklist' },
          { name: '标注文档', url: '/annodoc', imageName: 'doc' },
          { name: '开始测试', url: '/examlist', imageName: 'exam' },
          {
            name: '个人中心',
            sub: [
              { name: '标注统计', url: '/salary' },
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        annotator: [
          { name: '我的任务', url: '/tasklist', imageName: 'tasklist' },
          { name: '错误列表', url: '/incorrectlist', imageName: 'tasklist' },
          { name: '标注文档', url: '/annodoc', imageName: 'doc' },
          { name: '开始练习', url: '/examlist', imageName: 'exam' },
          { name: '匹配标注任务', url: '/match-task/list', imageName: 'tasklist' },
          {
            name: '个人中心',
            sub: [
              { name: '标注统计', url: '/salary' },
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        approverTwo: [
          { name: '我的任务', url: '/tasklist', imageName: 'tasklist' },
          { name: '错误列表', url: '/incorrectlist', imageName: 'tasklist' },
          { name: '标注文档', url: '/annodoc', imageName: 'doc' },
          // { name: '开始练习', url: '/examlist', imageName: 'exam' },
          {
            name: '个人中心',
            sub: [
              { name: '标注统计', url: '/salary' },
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        reviewer: [
          { name: '模型审核', url: '/model/audit/list', imageName: 'audit' },
          {
            name: '个人中心',
            sub: [
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
        default: [
          { name: '开始练习', url: '/examlist', imageName: 'exam' },
          { name: '标注文档', url: '/annodoc', imageName: 'doc' },
          {
            name: '个人中心',
            sub: [
              { name: '修改信息', url: '' },
              { name: '退出登录', url: '' },
            ],
            imageName: 'account',
          },
        ],
      },
      userInfoModalVisible: false,
      form: {
        username: '',
        password: '',
        checkPass: '',
      },
      rules: {
        username: [
          {
            validator: validateUsername,
            trigger: 'blur',
          },
        ],
        password: [
          {
            validator: validatePass,
            trigger: 'blur',
          },
        ],
        checkPass: [
          {
            validator: validateCheckPass,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted: function() {
    this.form.username = this.$store.state.userName;
    this.menuList = this.menuList[this.$store.state.role];
  },
  methods: {
    to(url) {
      this.$store.commit('setKeepAlive', []);
      this.$router.push(url);
    },
    logout() {
      window.localStorage.removeItem('hsJwt');
      window.localStorage.removeItem('code');
      // window.location.reload();
      router.push({ path: '/login' });
    },
    closeDialog(done) {
      this.$refs.ruleForm.resetFields();
      done();
    },
    changeUserInfo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          api
            .changeUserInfo({ password: md5(md5(this.form.password) + passwordSalt), username: this.form.username })
            .then(() => {
              this.$message.success('用户信息更新成功, 请重新登录');
              setTimeout(() => {
                this.userInfoModalVisible = false;
                this.logout();
              }, 1000);
            })
            .catch(() => {});
        }
      });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.left-navigation {
  padding: 0px;
  background: #2e323f;
  width: 251px;
  height: 100%;
  min-height: 800px;
  position: absolute;
  left: 0px;
  top: 0px;
  box-sizing: border-box;
  z-index: 99;
}
#logo {
  margin: 40px 36px 60px;
}
#logo img {
  height: 30px;
  vertical-align: top;
}
#logo span {
  color: #ffffff;
  font-size: 24px;
  margin-left: 8px;
}
.menu-item {
  height: 56px;
  width: 100%;
  box-sizing: border-box;
}
.menu-item.active {
  background: #567cab;
}
.item-title {
  color: #ffffff;
  padding: 18px 50px;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
}
.item-subtitle {
  cursor: pointer;
  font-size: 14px;
  color: #ffffff;
  padding: 0px 0px 24px 79px;
  box-sizing: border-box;
  text-align: left;
}
.item-title > img {
  width: 14px;
  height: 14px;
  margin-right: 16px;
  padding-top: 4px;
  vertical-align: top;
}
.icp-info {
  display: block;
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  width: 100%;
}
</style>
